import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { ProductCategoryAction, useProductCategoryProvider } from '../ProductCategory.Hooks';

export default function ProductCategoryList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useProductCategoryProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.programs}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.code}</th>
          <th>{lang.name}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: productCategory }) => (
            <tr key={productCategory.id}>
              <td>
                <b>{productCategory.code}</b>
              </td>
              <td>{productCategory.name}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: productCategory.id.toString(),
                      action: ProductCategoryAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_PRODUCT}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: productCategory.id.toString(),
                      action: ProductCategoryAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_PRODUCT}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
